export enum CallListType {
  CallList = "CallList",
  ContactList = "ContactList"
}
